/**
 * Swiper documentation:
 * https://swiperjs.com/swiper-api
 */
import { Swiper, Navigation, Autoplay } from 'swiper';
Swiper.use([Navigation, Autoplay]);

function initCarousel() {
  if ($('.swiper-carousel').length) {
    $('.swiper-carousel').each(function(index, element){
      const instance = $(this).data('instance');

      index = new Swiper(element, {
        speed: 500,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 32,
        observer: true,
        observeParents: true,
        autoplay: false,
        autoHeight: true,
        navigation: {
          nextEl: '#swiper-button-next-' + instance,
          prevEl: '#swiper-button-prev-' + instance,
        },
      });

      index.on('slideChangeTransitionStart', function () {
        const currentSlide = index.realIndex + 1;
        $('#current-' + instance).html(currentSlide.toString().padStart(2, '0'));
      });
    });
  }
}

export { initCarousel }



// WEBPACK FOOTER //
// ./scripts/modules/slider.js